export default {
  formId: "default",
  splash: {
    callToAction:
      "Apply to become a NativeScript Ambassador! If you're a college student or junior developer interested in using NativeScript to build mobile apps this summer, paired with a mentor who will help you learn and grow as a developer, this program may be for you!",
    button: "Let's Get It",
  },
  questions: [
    {
      type: "splash",
    },
    {
      question: "Arrange with your preference",
      type: "arrange",
      answers: [
        {
          answer: ["Technology", "Outing", "Travelling", "Reading "],
        },
        {
          answer: ["Outing", "Technology", "Travelling", "Reading "],
        },
        {
          answer: ["Travelling", "Technology", "Outing", "Reading "],
        },
        {
          answer: ["Reading ", "Technology", "Outing", "Travelling"],
        },
      ],
      small: "Arrange with your preferences",
    },
    {
      question: "Do you identify as a woman?",
      type: "single",
      answers: [
        {
          answer: "Yes",
        },
        {
          answer: "No",
        },
      ],
    },
    {
      question: "Which email address shall we use?",
      small: "Don't worry, we're not going to spam you.",
      type: "email",
    },
    {
      question:
        "Which mentor would you like to work with, if you have a choice?",
      type: "multiple",
      answers: [
        {
          answer: "Sherman Chen",
          action: "continue",
          key: "A",
        },
        {
          answer: "The Brosteins",
          action: "continue",
          key: "B",
        },
        {
          answer: "Alex Ziskind",
          action: "continue",
          key: "C",
        },
        {
          answer: "Nic Raboy",
          action: "continue",
          key: "D",
        },
        {
          answer: "Brad Martin",
          action: "continue",
          key: "E",
        },
        {
          answer: "Doesn't matter to me!",
          action: "continue",
          key: "F",
        },
      ],
    },
    {
      id: "thank-you",
      question: "Thank you!",
      type: "submit",
    },
  ],
};
